import React, { useRef, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { DownloadIcon, SquareStackIcon } from '@/icons';
import { Drawer, DrawerContent, DrawerTitle, DrawerTrigger } from '@/ui_v3';
import { type QRCodeSectionProps } from './DesktopQRCodeSection';
import { QRCodeBox } from './QRCodeBox';
export const MobileQRCodeSection: React.FC<Omit<QRCodeSectionProps, 'isQRCodeCopied'>> = ({
  url,
  onDownload,
  onCopy
}) => {
  const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState<boolean>(false);
  const {
    t
  } = useTranslation(['common']);
  const qrCodeRef = useRef<HTMLDivElement>(null);
  return <Drawer open={isMobileDrawerOpen} onOpenChange={setIsMobileDrawerOpen} data-sentry-element="Drawer" data-sentry-component="MobileQRCodeSection" data-sentry-source-file="MobileQRCodeSection.tsx">
      <DrawerTrigger asChild data-sentry-element="DrawerTrigger" data-sentry-source-file="MobileQRCodeSection.tsx">
        <QRCodeBox url={url} ref={qrCodeRef} flexible data-sentry-element="QRCodeBox" data-sentry-source-file="MobileQRCodeSection.tsx" />
      </DrawerTrigger>
      <DrawerContent className="max-h-[50vh] w-full px-md" hasDrawerHandle={true} hasDim={true} onDimClick={() => setIsMobileDrawerOpen(false)} data-sentry-element="DrawerContent" data-sentry-source-file="MobileQRCodeSection.tsx">
        {/* 번역된 액션 목록 자체를 시트 이름으로 쓴다. */}
        <DrawerTitle asChild data-sentry-element="DrawerTitle" data-sentry-source-file="MobileQRCodeSection.tsx">
          <div className="flex flex-col pb-lg pt-xs">
            <div className="flex items-center gap-xs px-2xs py-[10px] text-body-lg-medium" onClick={() => {
            if (qrCodeRef.current) {
              onDownload(qrCodeRef.current);
            }
            setIsMobileDrawerOpen(false);
          }}>
              <DownloadIcon data-sentry-element="DownloadIcon" data-sentry-source-file="MobileQRCodeSection.tsx" />
              <span>{t('global.download.button')}</span>
            </div>
            <div className="flex items-center gap-xs px-2xs py-[10px] text-body-lg-medium" onClick={() => {
            if (qrCodeRef.current) {
              onCopy(qrCodeRef.current);
            }
            setIsMobileDrawerOpen(false);
          }}>
              <SquareStackIcon data-sentry-element="SquareStackIcon" data-sentry-source-file="MobileQRCodeSection.tsx" />
              <span>{t('global.copy.button')}</span>
            </div>
          </div>
        </DrawerTitle>
      </DrawerContent>
    </Drawer>;
};